import { configureStore } from '@reduxjs/toolkit';
import { loginSlice } from '../features/login/slices/login.slice';
import { userSlice } from '../features/user/slices/user.slice';
import { offersSlice } from '../features/offers/slices/offers.slice';
import { meSlice } from '../features/login/slices/me.slice';

export const store = configureStore({
  reducer: {
    auth: loginSlice.reducer,
    user: userSlice.reducer,
    me: meSlice.reducer,
    offers: offersSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
